// frontend/src/store/modules/wechatAuth.js
import sharedWechatAuthModule, { setApiGetter } from '@shared-library/store/modules/wechatAuth.js';
import api from '@/api';

// 设置 API getter
setApiGetter(() => api);

// 前端可以直接使用共享库中的wechatAuth模块
export default sharedWechatAuthModule;